import { formatAed } from '../../utils/dealer';

/** An AED amount, kept LTR inside RTL text (requirements §4 RTL). */
export default function Money({ value, className = '' }: { value: string | number | null | undefined; className?: string }) {
  return <span className={`dealer-money ${className}`.trim()} dir="ltr">{formatAed(value)}</span>;
}
